import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CosmicController from "../../controllers/cosmicController";
import MarkdownBlock from "../markdownBlock";
import c from "./styles.module.scss";
import Container from "../container";

function normalizeUrl(url) {
  const u = new URL(url, "http://dummy");

  const params = [...u.searchParams.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([k, v]) => `${k}=${v}`)
    .join("&");

  return u.pathname + (params ? `?${params}` : "");
}

const SeoText = () => {
  const location = useLocation();
  const [texts, setTexts] = useState([]);

  useEffect(() => {
    const getTexts = async () => {
      const response = await CosmicController.getTexts();

      if (response.success) {
        setTexts(response.data || []);
      }
    };

    getTexts();
  }, []);

  const currentUrl = normalizeUrl(location.pathname + location.search);
  const page = texts.find((t) => currentUrl.includes(normalizeUrl(t.link)));

  if (!page) return null;

  return (
    <section className={c.section}>
      <Container>
        <MarkdownBlock body={page.text} />
      </Container>
    </section>
  );
};

export default SeoText;
